import { queryOptions } from "@tanstack/react-query";
import { SetErrorMessageType } from "@/app/providers/ReactContextProvider/types";
import { QUERY_KEYS, STALE_TIME_SHORT } from "@/common/api/constants";
import { fetchLatestLead } from "@/entities/lead/api/requests";

interface Props {
  token: string;
  setErrorMessage: SetErrorMessageType;
  refetchOnWindowFocus?: boolean;
}

export const getLeadQueryOption = ({
  token,
  setErrorMessage,
  refetchOnWindowFocus = true,
}: Props) =>
  queryOptions({
    queryKey: [QUERY_KEYS.FETCH_LATEST_LEAD, token, setErrorMessage],
    queryFn: () => fetchLatestLead({ token, setErrorMessage }),
    enabled: !!token,
    staleTime: STALE_TIME_SHORT,
    refetchOnWindowFocus,
  });
